import {BASE_URL} from '@/services/api'
import {METHOD, request} from '@/utils/request'

let LOG_LIST= `${BASE_URL}/log/getLogList`
let GET_MY_LOGLIST= `${BASE_URL}/log/getMyLogList`

export async function GetLogList(params) {
  return request(LOG_LIST, METHOD.POST, params)
}

export async function GetMyLogList(params) {
  return request(GET_MY_LOGLIST, METHOD.POST, params)
}


export default {
}
